@switch (currentSettings()) {
    @case (settingEnum.MAIN) {
        <web-widget-breadcrumbs [widget]="widget()" [hideBreadcrumbs]="isZero" [isInSpecificSection]="isSpecific()" />
        <div class="panel-options-body overflow-wrapper">
            <p class="text-muted mb-5">{{ "form_prompt_text" | translate }}</p>
            <div class="form-group mb-20">
                <span class="dropdown dropdown-chains" dropdown>
                    <a class="dotted-toggle" data-toggle="dropdown" dropdownToggle>
                        <span class="selected-chain">{{ getCRMCreationType() }}</span>
                    </a>
                    <ul class="dropdown-menu dropdown-overflow-wrapper dropdown-menu-center" *dropdownMenu>
                        <li class="padding-10">
                            @if (!form.createContactAndDeal().value()) {
                                <a
                                    class="small text-nowrap"
                                    [title]="CREATE_DEAL_AND_CONTACT[0].label"
                                    (click)="setCRMCreationType(CREATE_DEAL_AND_CONTACT[0].value)"
                                >
                                    {{ CREATE_DEAL_AND_CONTACT[0].label }}
                                </a>
                            }
                            @if (form.createContactAndDeal().value()) {
                                <a
                                    class="small text-nowrap"
                                    [title]="CREATE_DEAL_AND_CONTACT[1].label"
                                    (click)="setCRMCreationType(CREATE_DEAL_AND_CONTACT[1].value)"
                                >
                                    {{ CREATE_DEAL_AND_CONTACT[1].label }}
                                </a>
                            }
                        </li>
                    </ul>
                </span>
            </div>
            @if (isCrmDisabled()) {
                <div class="alert alert-warning">
                    <a href="/crm/deals" target="_blank"
                        >{{ "crm_not_initialized_link" | translate }}
                        <img class="font-icon" src="./assets/img/websites/lpc-new-window-icon.svg" />
                    </a>
                    {{ "crm_not_initialized_text" | translate }}
                </div>
            } @else {
                @if (form.createContactAndDeal().value()) {
                    <div class="form-group mb-20" [class.has-error]="form.dealName().errors().length">
                        <label>
                            {{ "crm_deal_name" | translate }}
                        </label>
                        <input
                            class="form-control"
                            type="text"
                            [value]="form.dealName().value() ?? ''"
                            (input)="onDealNameInput($event)"
                        />
                        @if (form.dealName().errors().length) {
                            <span class="help-block small">
                                {{ "control_errors_required" | translate }}
                            </span>
                        }
                    </div>
                    <web-crm-pipelines-collection
                        [selectedPipeline]="form.selectedPipeline().value()"
                        [selectedPipelineStep]="form.selectedPipelineStep().value()"
                        [isCrmDisabled]="isCrmDisabled()"
                        [crmPipelines]="crmPipelines()"
                        [isLoading]="crmPipelinesQuery.isLoading()"
                        [isError]="crmPipelinesQuery.isError()"
                        (selectedPipelineChange)="setPipeline($event)"
                        (selectedPipelineNameChange)="setPipelineName($event)"
                    />
                }
                <div class="mb-10">
                    <div class="form-group form-horizontal row mb-10">
                        <label class="control-label col-xs-9">
                            {{ "add_tags_crm" | translate }}
                        </label>
                        <div class="col-xs-3 control-switch text-right">
                            <sp-switch
                                [active]="!!form.addCrmTags().value()"
                                (toggleActiveEvent)="toggleAddCrmTags($event)"
                            />
                        </div>
                    </div>
                    @if (form.addCrmTags().value()) {
                        <web-tags-collection
                            [selected]="form.contactTags().value() ?? []"
                            (selectedChange)="onContactTagsChange($event)"
                            [tags]="crmTags()"
                            [isLoading]="crmTagsQuery.isPending()"
                            [isError]="crmTagsQuery.isError()"
                        />
                    }
                </div>
                <div>
                    <div class="form-group form-horizontal row mb-10">
                        <label class="control-label col-xs-9">
                            {{ "add_address_book" | translate }}
                        </label>
                        <div class="col-xs-3 control-switch text-right">
                            <sp-switch
                                [active]="!!form.createAddressBook().value()"
                                (toggleActiveEvent)="toggleAddressBookSettings($event)"
                            />
                        </div>
                    </div>
                    @if (form.createAddressBook().value()) {
                        <sp-address-books-ui
                            [data]="addressBooksQuery.data() ?? []"
                            [isLoading]="addressBooksQuery.isPending()"
                            [isError]="addressBooksQuery.isError()"
                            [selected]="form.selectedAddressBook().value() ?? null"
                            (selectedChange)="onSelectedAddressBookChange($event)"
                        />
                    }
                </div>
                @if (form.createAddressBook().value() && form.selectedAddressBook().value()) {
                    <div class="well well-sm mb-10" style="margin-top: -9px; border-radius: 0 0 10px 10px">
                        <div class="form-group form-horizontal row mb-10">
                            <label class="control-label col-xs-9">
                                {{ "add_tags_address_book" | translate }}
                            </label>
                            <div class="col-xs-3 control-switch text-right">
                                <sp-switch
                                    [active]="!!form.addAddressBookTags().value()"
                                    (toggleActiveEvent)="toggleAddAddressBookTags($event)"
                                ></sp-switch>
                            </div>
                        </div>

                        @if (form.addAddressBookTags().value()) {
                            <web-tags-collection
                                [selected]="form.contactAddressBookTags().value() ?? []"
                                (selectedChange)="onContactAddressBookTagsChange($event)"
                                [tags]="addressBooksTags()"
                                [isLoading]="addressBooksTagsQuery.isPending()"
                                [isError]="addressBooksTagsQuery.isError()"
                            />
                        }
                    </div>
                }
            }
            <div class="mb-20">
                <div class="form-group form-horizontal row">
                    <label class="control-label col-xs-9">
                        {{ "add_chat_bot_to_form" | translate }}
                    </label>
                    <div
                        class="col-xs-3 control-switch text-right"
                        [tooltip]="checkExistingChatBotsNumber() === 0 ? ('chat_bots_disable_tooltip' | translate) : ''"
                    >
                        <sp-switch
                            [active]="!!form.addChatBotToForm().value()"
                            [disabled]="checkExistingChatBotsNumber() === 0"
                            (toggleActiveEvent)="toggleChatBotsSettings($event)"
                        />
                    </div>
                </div>
                @if (form.addChatBotToForm().value()) {
                    <div class="form-group form-horizontal row">
                        <div
                            class="col-xs-12"
                            cdkDropList
                            [cdkDropListData]="form.chatBots().value()"
                            (cdkDropListDropped)="dropChatBotElementItem($event)"
                        >
                            <label>
                                {{ "chat_bots_buttons" | translate }}
                            </label>
                            <a class="dotted pull-right" (click)="openSettings(settingEnum.CHAT_BOT_BUTTON_STYLES)">
                                {{ "chat_bots_buttons_styles" | translate }}
                            </a>
                            @for (chatBot of form.chatBots().value(); track $index; let i = $index) {
                                <div cdkDrag cdkDropListGroup [cdkDragData]="chatBot">
                                    <sp-control-handle
                                        [controlHandleBtn]="true"
                                        [controlHandleIcon]="getSocialNetworkIconSrcByChatBot(chatBot)"
                                        [controlHandleMainText]="chatBot.name"
                                        [controlHandleSubText]="getChatBotSubText(chatBot)"
                                        [controlHandleSubTextWarning]="!chatBot.link"
                                        (editActionEvent)="editChatBot(i)"
                                        (removeActionEvent)="removeSocial(i)"
                                    />
                                </div>
                            }
                            <a
                                class="dotted"
                                [class.disabled]="form.chatBots().value().length >= checkExistingChatBotsNumber()"
                                (click)="addChatBot()"
                                >{{ "add" | translate }}</a
                            >
                        </div>
                    </div>
                }
            </div>
            <hr class="panel-options-divider" />
            <div
                class="form-group row"
                [class.mb-10]="form.formView().value() === EFormView.modal"
                [class.mb-20]="form.formView().value() === EFormView.static"
            >
                <div class="col-xs-12">
                    <label>
                        {{ "control_view" | translate }}
                    </label>
                    <a class="dotted pull-right" (click)="openSettings(settingEnum.INPUT)">
                        {{ "control_form_fields_styles" | translate }}
                    </a>
                </div>
                <div class="col-xs-12">
                    <div class="appearance-wrapper">
                        <div
                            class="appearance-block"
                            [class.active]="form.formView().value() === EFormView.static"
                            [tooltip]="staticForm"
                            (click)="setFormView(EFormView.static)"
                        >
                            <img src="./assets/img/websites/lpc-static-form-icon.svg" alt="static form" />
                            <ng-template #staticForm>
                                {{ "control_static_form_tooltip" | translate }}
                            </ng-template>
                        </div>
                        <div
                            class="appearance-block"
                            [class.active]="form.formView().value() === EFormView.modal"
                            [tooltip]="modalForm"
                            (click)="setFormView(EFormView.modal)"
                        >
                            <img src="./assets/img/websites/lpc-modal-form-icon.svg" alt="modal form" />
                            <ng-template #modalForm>
                                {{ "control_modal_form_tooltip" | translate }}
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>
            @if (form.formView().value() === EFormView.modal) {
                <div class="form-group form-horizontal row">
                    <label class="control-label col-xs-9">
                        {{ "control_two_step_form" | translate }}
                        <span
                            class="sp-icon icon-info-bold small color-light"
                            [tooltip]="'two_step_form_hint' | translate"
                        >
                        </span>
                    </label>
                    <div class="col-xs-3 control-switch text-right">
                        <sp-switch
                            [active]="!!form.isTwoStepForm().value()"
                            (toggleActiveEvent)="toggleTwoStepForm($event)"
                        />
                    </div>
                </div>
                <div class="form-group mb-20">
                    <label>
                        {{ "control_form_modal_title" | translate }}
                    </label>
                    <input
                        class="form-control"
                        type="text"
                        [value]="form.modalTitle().value() ?? ''"
                        (input)="onModalTitleInput($event)"
                    />
                </div>
            }
            <div
                class="mb-20"
                cdkDropList
                [cdkDropListData]="form.elements().value()"
                (cdkDropListDropped)="dropElementItem($event)"
            >
                <label>
                    {{ "control_form_fields" | translate }}
                </label>
                @for (input of form.elements().value(); track $index; let i = $index) {
                    <div cdkDrag cdkDropListGroup [cdkDragData]="input">
                        <sp-control-handle
                            [controlHandleBtn]="form.elements().value().length === 1 ? false : true"
                            [controlHandleDisableDelete]="
                                form.elements().value().length === 1 || isDisabledDelete(input)
                            "
                            [controlHandleIcon]="getControlHandleIcon(input.type)"
                            [controlHandleMainText]="input.label"
                            (removeActionEvent)="removeInput(i)"
                            (editActionEvent)="editInput(i)"
                        >
                            <span cdkDragHandle></span>
                            <ng-template #variablesTemplate>
                                <sp-variables-popover
                                    [element]="$any(input)"
                                    [addressBookVariablesList]="
                                        addressBookVariablesById(form.selectedAddressBook().value())
                                    "
                                    [crmContactsVariablesList]="crmContacts()"
                                    [crmDealsVariablesList]="crmDeals()"
                                    [createAddressBook]="!!form.createAddressBook().value()"
                                    [isCrmDealsListDisabled]="!form.createContactAndDeal().value()"
                                />
                            </ng-template>
                        </sp-control-handle>
                    </div>
                }
                <a class="dotted" (click)="addInput()">{{ "add" | translate }}</a>
            </div>
            @if (
                !form.addChatBotToForm().value() ||
                (form.addChatBotToForm().value() && form.formView().value() === EFormView.modal)
            ) {
                <div class="mb-20">
                    @if (form.formView().value() === EFormView.static) {
                        <label>
                            {{ "form_button" | translate }}
                        </label>
                    }
                    @if (form.formView().value() === EFormView.modal) {
                        <label>
                            {{ "form_buttons" | translate }}
                        </label>
                    }
                    <sp-control-handle
                        [controlHandleMainText]="form.formButtonSettings().value().label"
                        (editActionEvent)="openSettings(settingEnum.BUTTON)"
                    />
                    @if (!form.addChatBotToForm().value() && form.formView().value() === EFormView.modal) {
                        <sp-control-handle
                            [controlHandleMainText]="form.modalFormButtonSettings().value().label"
                            [controlHandleSubText]="'control_modal_button_subtext' | translate"
                            (editActionEvent)="openSettings(settingEnum.FORM_BUTTON)"
                        />
                    }
                </div>
            }
            <div class="mb-20">
                <div class="form-group form-horizontal row">
                    <label class="control-label col-xs-6">
                        {{ "control_align_content" | translate }}
                    </label>
                    <div class="col-xs-6">
                        <sp-radio-group
                            [selected]="form.inputSettings().value().horizontalPosition"
                            [type]="radioGroupType.horizontalPosition"
                            (changeSelectedEvent)="setInputSettingsHorizontalPosition($event)"
                        />
                    </div>
                </div>
            </div>
            <div class="mb-10">
                <div class="device-toggle-wrapper">
                    <web-device-toggle />
                    @if (!isZero) {
                        <!-- Truthy check on purpose: legacy persisted widgets may hold `null`,
                             which the FormGroup editor treated as "off". -->
                        <web-synchronize-style-toggle
                            [active]="!!form.isSynchronizeStyle().value()"
                            (click)="form.setIsSynchronizeStyle(!form.isSynchronizeStyle().value())"
                        />
                    }
                </div>
            </div>
            <div class="form-group mb-0">
                @if (isDeviceDesktop()) {
                    <p class="help-block text-muted small">
                        {{ "desktop_device_hint" | translate }}
                    </p>
                }

                @if (isDeviceTablet()) {
                    <p class="help-block text-muted small">
                        {{ "tablet_device_hint" | translate }}
                    </p>
                }

                @if (isDeviceMobile()) {
                    <p class="help-block text-muted small">
                        {{ "mobile_device_hint" | translate }}
                    </p>
                }
            </div>
            @if (isZero) {
                <div class="form mt-20 mb-20 form-horizontal">
                    <sp-extended-position-signal-settings
                        [position]="zeroPosition()"
                        [isMobile]="isDeviceMobile()"
                        [isTablet]="isDeviceTablet()"
                        [parentId]="widget().columnId"
                        (valueChangeEvent)="onZeroPositionChange($event)"
                    />
                </div>
            } @else {
                <div class="form mt-20 mb-20 form-horizontal">
                    <web-widget-position-settings
                        [isTablet]="isDeviceTablet()"
                        [isMobile]="isDeviceMobile()"
                        [isSynchronized]="!!form.isSynchronizeStyle().value()"
                        [widgetId]="widget().id"
                        [columnId]="widget().columnId"
                        [position]="$any(form.position().value())"
                        (positionChange)="onPositionChange($any($event))"
                    />
                </div>
            }
            <hr class="panel-options-divider" />
            <div class="form mt-20 mb-20 form-horizontal">
                @if (isZero) {
                    <web-widget-extended-hide-settings
                        [hideOnDesktop]="!!form.hideOnDesktop().value()"
                        [hideOnTablet]="!!form.hideOnTablet().value()"
                        [hideOnMobile]="!!form.hideOnMobile().value()"
                        (hideOnDesktopChange)="form.setHideOnDesktop($event)"
                        (hideOnTabletChange)="form.setHideOnTablet($event)"
                        (hideOnMobileChange)="form.setHideOnMobile($event)"
                    />
                } @else {
                    <web-widget-hide-settings
                        [hideOnDesktop]="!!form.hideOnDesktop().value()"
                        [hideOnTablet]="!!form.hideOnTablet().value()"
                        [hideOnMobile]="!!form.hideOnMobile().value()"
                        (hideOnDesktopChange)="form.setHideOnDesktop($event)"
                        (hideOnTabletChange)="form.setHideOnTablet($event)"
                        (hideOnMobileChange)="form.setHideOnMobile($event)"
                    />
                }
            </div>
            <hr class="panel-options-divider" />
            <div class="mb-20">
                <a class="dotted" (click)="openSettings(settingEnum.ADDITIONAL)">
                    {{ "additional_form_settings" | translate }}
                </a>
            </div>
            <div>
                <a class="dotted" (click)="openSettings(settingEnum.ANALYTICS)">
                    {{ "analytics_form_settings" | translate }}
                </a>
            </div>
            <div class="mt-20">
                <web-custom-id [displayId]="form.displayId()" (valueChangeEvent)="form.setDisplayId($event)" />
            </div>
        </div>
    }
    @case (settingEnum.BUTTON) {
        <web-form-button-settings
            [form]="form"
            [isHorizontalForm]="form.inputSettings().value().formStyleType === FormStyleEnum.HORIZONTAL"
            (saveEvent)="closeSettings()"
            (cancelEvent)="closeSettings()"
        />
    }
    @case (settingEnum.FORM_BUTTON) {
        <web-form-button-settings
            [form]="form"
            [isModalButton]="true"
            [isHorizontalForm]="form.inputSettings().value().formStyleType === FormStyleEnum.HORIZONTAL"
            (saveEvent)="closeSettings()"
            (cancelEvent)="closeSettings()"
        />
    }
    @case (settingEnum.ELEMENT) {
        <web-form-element-settings
            [form]="form"
            [index]="editedInputIndex() ?? 0"
            [addChatBotToForm]="!!form.addChatBotToForm().value()"
            [addressBookVariablesList]="addressBookVariablesById(form.selectedAddressBook().value())"
            [crmContactsVariablesList]="crmContacts()"
            [crmDealsVariablesList]="crmDeals()"
            [isAddressBookListDisabled]="!form.createAddressBook().value()"
            (saveEvent)="closeSettings()"
            (cancelEvent)="closeSettings()"
        />
    }
    @case (settingEnum.INPUT) {
        <web-form-input-settings
            [form]="form"
            [isModalForm]="form.formView().value() === EFormView.modal"
            [isTwoStepForm]="!!form.isTwoStepForm().value()"
            (saveEvent)="closeSettings()"
            (cancelEvent)="closeSettings()"
        />
    }
    @case (settingEnum.ADDITIONAL) {
        <web-form-additional-settings
            [form]="form"
            [addChatBotToForm]="!!form.addChatBotToForm().value()"
            (saveEvent)="closeSettings()"
            (cancelEvent)="closeSettings()"
        />
    }
    @case (settingEnum.ANALYTICS) {
        <web-analytics-settings-signal-legacy
            [settings]="form.analyticsSettings().value() ?? null"
            [pixelAnalyticType]="pixelTypes.lead"
            (valueChangeEvent)="onAnalyticsSettingsChange($event)"
            (cancelEvent)="closeSettings()"
        />
    }
    @case (settingEnum.CHAT_BOT_SETTINGS) {
        <web-form-chat-bot-settings
            [form]="form"
            [isSubscriptionForm]="true"
            [chatBot]="editingChatBot()"
            [selectedChatbots]="form.chatBots().value()"
            [existingChatBots]="existingChatBots()"
            [chatBotsList]="$any(chatBots$(editingChatBot()?.socialNetwork) | async)"
            (valueChangeEvent)="onEditingChatBotChange($event)"
            (saveEvent)="closeSettings()"
            (cancelEvent)="closeSettings()"
        />
    }
    @case (settingEnum.CHAT_BOT_BUTTON_STYLES) {
        <web-form-chat-bot-button-settings
            [form]="form"
            (saveEvent)="closeSettings()"
            (cancelEvent)="closeSettings()"
        />
    }
}
